// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import { MrAppLayout, MrHeaderTabs, MrTab, MrTabList, MrTabPanel } from '@ion/components';

import { routes } from 'app/constants';
import MrTabPanelBase from 'app/components/MrTabPanelBase';
import AppHeader from 'app/components/app-header';
import SideNav from 'app/components/side-nav';
import EventsTab from './EventsTab';
import SchemasTab from './SchemasTab';
import SchemaLibrariesTab from './SchemaLibrariesTab';

export default function SchemaEnforcementPage() {
  return (
    <MrAppLayout
      title="Schema Enforcement"
      header={<AppHeader icon="schemas" title="Schema Enforcement" route={routes.schemas} />}
      sideNav={<SideNav />}
    >
      <MrHeaderTabs>
        <MrTabList>
          <MrTab>Schema Libraries</MrTab>
          <MrTab>Events</MrTab>
          <MrTab>Schemas</MrTab>
        </MrTabList>

        <MrTabPanel>
          <MrTabPanelBase>
            <SchemaLibrariesTab />
          </MrTabPanelBase>
        </MrTabPanel>

        <MrTabPanel>
          <MrTabPanelBase>
            <EventsTab />
          </MrTabPanelBase>
        </MrTabPanel>

        <MrTabPanel>
          <MrTabPanelBase>
            <SchemasTab />
          </MrTabPanelBase>
        </MrTabPanel>
      </MrHeaderTabs>
    </MrAppLayout>
  );
}
